import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    atmLimit: 'Withdrawal limits',
    description: '{amount} of {maxAmount}',
    editAtmLimit: 'Withdrawal (30 rolling days)',
    editPaymentLimit: 'Payment (7 rolling days)',
    editPaymentLimitAll: 'Budget tracking',
    paymentLimit: 'Payment limits',
  },
  fr: {
    atmLimit: 'Plafond de retrait',
    description: '{amount} sur {maxAmount}',
    editAtmLimit: 'Retraits (30 jours glissants)',
    editPaymentLimit: 'Paiement (7 jours glissants)',
    editPaymentLimitAll: 'Suivi du budget',
    paymentLimit: 'Plafond de paiement',
  },
});

export default locales;
